/* Activewear UI polish: clean SVG icons instead of text arrows (iOS draws ↗ › → as emoji),
   calm focus on touch-opened dialogs. Loaded synchronously at the end of <body>. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var PATHS = {
    right: 'M9 5l7 7-7 7',
    left: 'M15 5l-7 7 7 7',
    up: 'M5 15l7-7 7 7',
    down: 'M5 9l7 7 7-7',
    'arrow-right': 'M4 12h15M13 6l6 6-6 6',
    'arrow-left': 'M20 12H5M11 6l-6 6 6 6'
  };
  var GLYPHS = { '›': 'right', '❯': 'right', '‹': 'left', '❮': 'left', '→': 'arrow-right', '←': 'arrow-left', '↓': 'down' };
  var ANY = /[›❯‹❮→←↓↗↑]/;

  function icon(name) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'aw-icon aw-icon--' + name);
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', PATHS[name]);
    svg.appendChild(path);
    return svg;
  }

  function fixText(node) {
    var text = node.nodeValue;
    if (!ANY.test(text)) return;
    var parent = node.parentNode;
    if (!parent || /^(SCRIPT|STYLE|TEXTAREA|OPTION|TITLE)$/.test(parent.nodeName)) return;
    // "Price ↑" reads better as words; decorative ↗ is dropped.
    text = text.replace(/Price\s*↑/g, 'Price, low to high').replace(/\s*↗\s*/g, ' ').replace(/↑/g, '');
    var trimmed = text.trim();
    if (GLYPHS[trimmed]) {
      parent.replaceChild(icon(GLYPHS[trimmed]), node);
      return;
    }
    var match = text.match(/^(.*?)\s*([›❯→])\s*$/);
    if (match && match[1].trim()) {
      node.nodeValue = match[1].replace(/\s+$/, '') + ' ';
      parent.insertBefore(icon(GLYPHS[match[2]]), node.nextSibling);
      return;
    }
    var lead = text.match(/^\s*([‹❮←])\s*(.+)$/);
    if (lead) {
      node.nodeValue = ' ' + lead[2];
      parent.insertBefore(icon(GLYPHS[lead[1]]), node);
      return;
    }
    // Any glyph left mid-sentence is plain text noise: drop it (never rewrite unchanged text).
    text = text.replace(/[›❯‹❮→←↓]/g, '');
    if (text !== node.nodeValue) node.nodeValue = text;
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1 || !ANY.test(root.textContent || '')) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [], n;
    while ((n = walker.nextNode())) if (ANY.test(n.nodeValue)) nodes.push(n);
    nodes.forEach(fixText);
  }

  scan(document.body);
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      if (r.type === 'characterData') scan(r.target);
      else r.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  // Touch/mouse-opened dialogs: focus the panel itself, so no focus ring lands on the first icon.
  var pointer = false;
  document.addEventListener('pointerdown', function () { pointer = true; }, true);
  document.addEventListener('keydown', function () { pointer = false; }, true);
  var dialogs = document.querySelectorAll('dialog');
  var watcher = new MutationObserver(function (records) {
    records.forEach(function (r) {
      var d = r.target;
      if (!d.open || !pointer) return;
      if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');
      requestAnimationFrame(function () { d.focus({ preventScroll: true }); });
    });
  });
  dialogs.forEach(function (d) { watcher.observe(d, { attributes: true, attributeFilter: ['open'] }); });
})();
